import React from 'react'
import {
  Row,
  message,
  Input,
  Col,
  Button,
  Form,
  Select,
  Table,
  DatePicker,
  Popconfirm,
  Checkbox,
  Layout,
  Tooltip,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons'
import queryString from 'query-string'
import axios from 'axios'
import moment from 'moment'
import { Spin } from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import hasPermissions from '../../hooks/Permissions'
import { useParams, useLocation, useHistory } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import { postcssVersion } from 'postcss-normalize'
import { toast } from 'react-toastify'

const { Option } = Select
const productNameInLocalStorage = localStorage.getItem('productName')
const data = JSON.parse(localStorage.getItem('user'))

function roundvalue(value) {
  // for round the vlaues john 24 march 2022
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}
class EditQuotation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isCorprate: false,
      isCustomer: data?.role === '311',
      isInsurer: data?.role === '308',
      taxes: [],
      InsurerFirstName: data?.FirstName,
      InsurerLastName: data?.LastName,
      editingRecordId: null,
      quotationStatus: '',
      policyDuration: '12',
      quotationPermissions: {},
      policyPermissions: {},
      brokerId: 0,
      isApproved: false,
      isTableViible: 'false',
      searchBox: null,
      gotData: false,
      visible: false,
      visibleSearch: false,
      api: 'https://localhost:7279/GetClientDetailsbyid/1',
      access: '',
      a: false,
      riskCover: '',
      riskItem: '',
      coverType: '',
      data: [],
      riskCoverDrop: [],
      riskItemList: [],
      hasEdited: false,
      specificProductID: 0,
      selectedInsurer: 0,
      riskVar: '',
      ratePercentage: 0.0,
      rate: 0.0,
      riskcoverfortable: '',
      riskitemfortable: '',
      newProduct: {},
      annualPremiumTotal: 0.0,
      termPremiumTotal: 0.0,
      minimumPremium: 0,
      prorataPremiumTotal: 0.0, //johh 30-03-2022
      tempAddress: '',
      policyStartDate: '',
      policyEndDate: '',
      paymentterm: '', //john 24-03-2022
      monthlyTermPayment: 0,
      isMonthlyDeduction: false,
      policyriskcover: '', //john 24-03-2022
      record: '', //john 24-03-2022
      clientfirstname: '',
      clientsurname: '',
      clientcorporatename: '',
      clientcontactnumber: '',
      clientemailaddress: '',
      clientId: '',
      clientage: '',
      clientgender: '',
      clientaddress1: '',
      clientaddress2: '',
      nationalid: '',
      customerid: '',
      entitytype: '',
      suburb: '',
      city: '',
      VehicleRegistration: '',
      Make: '',
      Model: '',
      Year: '',
      riskItemStartDate: new Date(),
      currentDate: new Date(),
      stampDuty: '',
      reinsuranceLimit: '',
      loading: false,
      cellphone: false,
      currency: '',
      currencyList: [],
      insurerList: [],
      UserDetail: JSON.parse(localStorage.getItem('user')),
      riskCoverIdFromApi: 0,
      currencyFromApi: '',
      corporateType: '',
      sumInsuredTotalFCP: 0,
      monthlyPremiumTotal: 0,
      insurerID: 0,
      ageFcp: '',
      ageRanges: [],
      policyCoverValue: '',
      monthlyPaymentValues: 0,
      addressValue: '',
      DObValue: null,
      relationValue: '',
      sumInsuredValue: 0,
      riskItemValue: 'Select',
      genderValue: '',
      totalSumInsured: 0,
      Minimum_rate: 0,
      items: [],
      fieldsDisabled: true,
      selectedCurrency: '',
      footerTotals: {},
      grandTotals: {},
      columns: [
        {
          key: 'riskitem',
          title: 'Policy Cover',
          dataIndex: 'policy_cover',
        },
        {
          key: 'riski_tem',
          title: 'Risk Item',
          dataIndex: 'riskitemname',
        },
        {
          key: 'address',
          title: 'Address/Details',
          dataIndex: 'address',
        },
        ...(productNameInLocalStorage === 'LEGAL INSURANCE'
          ? [
            {
              key: 'monthlyPayment',
              title: 'Monthly Payment($)',
              dataIndex: 'monthlypremium',
            },
          ]
          : [
            {
              key: 'suminsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
            },
            {
              key: 'rate',
              title: 'Rate(%)',
              dataIndex: 'rate',
            },
            // {
            //   key: 'Proratapremium',
            //   title: 'Prorata Premium',
            //   dataIndex: 'prorata',
            // },
            {
              key: 'annualpremium',
              title: 'Annual Premium',
              dataIndex: 'annualpremium',
            },
            {
              key: 'termpremium',
              title: 'Term Premium',
              dataIndex: 'termpremium',
            },
          ]),
        {
          key: 'itempstartdate',
          title: 'Start Date',
          dataIndex: 'itempstartdate',
          render: (text, record) => {
            return moment(text).format('DD-MM-YYYY')
          }
        },
        {
          key: 'actions',
          title: 'Actions',
          render: (_, record, index) =>
            this.state.data.length >= 1 ? (
              <>
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(index)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
                <Popconfirm
                  title="Do you want to remove this Item?"
                  onConfirm={() => this.handleDelete(index)}>
                  <Tooltip title="Delete">
                    <Button
                      type="danger"
                      className="delete_btn"
                      style={{ marginLeft: 8 }}>
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              </>
            ) : null,
        },
      ],
      columnsForFCP: [
        {
          key: 'relation',
          title: 'Relationship',
          dataIndex: 'relationship',
          width: '10',
        },
        {
          key: 'riskitem',
          title: 'Policy Cover',
          dataIndex: 'policy_cover',
        },
        {
          key: 'riski_tem',
          title: 'Risk Item',
          dataIndex: 'riskitemname',
        },
        {
          key: 'name',
          title: 'Members Name',
          dataIndex: 'membername',
          width: '10',
        },
        {
          key: 'gender',
          title: 'Gender',
          dataIndex: 'gender',
          width: '10',
        },
        {
          key: 'age',
          title: 'Age',
          dataIndex: 'age',
          width: '10',
        },
        ...(parseInt(localStorage.getItem('productId')) === 3
          ? [
            {
              key: 'sumInsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              render: suminsured => {
                return parseFloat(suminsured).toFixed(2)
              },
              width: '10',
            },
            // {
            //   key: 'Proratapremium',
            //   title: 'Prorata Premium',
            //   dataIndex: 'prorata',
            //   width: '10',
            // },
            {
              key: 'annualpremium',
              title: 'Annual Premium',
              dataIndex: 'annualpremium',
              width: '10',
            },
            {
              key: 'termpremium',
              title: 'Term Premium',
              dataIndex: 'termpremium',
              width: '10',
            },
          ]
          : [
            {
              key: 'sumInsured',
              title: 'Sum Insured',
              dataIndex: 'suminsured',
              hidden: true,
            },
            // {
            //   key: 'Proratapremium',
            //   title: 'Prorata Premium',
            //   dataIndex: 'prorata',
            // },
            {
              key: 'annualpremium',
              title: 'Annual Premium',
              dataIndex: 'annualpremium',
            },

            {
              key: 'termpremium',
              title: 'Term Premium',
              dataIndex: 'termpremium',
            },
          ]),
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record, index) =>
            this.state.data.length >= 1 ? (
              <>
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(index)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
                <Popconfirm
                  title="Do you want to remove this Item?"
                  onConfirm={() => this.handleDelete(index)}>
                  <Tooltip title="Delete">
                    <Button
                      type="danger"
                      className="delete_btn"
                      style={{ marginLeft: 8 }}>
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              </>
            ) : null,
        },
      ],
      // Variables for fetching user info
      res: [],
      clientName: '',
      quotationNumber: '',
      startDateFromApi: '',
      endDateFromApi: '',
      riskCoverFromApi: [],
      riskItemFromApi: '',
      quotationId: this.props.match.params.quotationId,
      quotationIdLocal: 0,
      termPremiumTotalForEdit: 0.0,
      annualPremiumTotalForEdit: 0.0,
      prorataPremiumTotalForEdit: 0.0,
      riskitemid: '',
      dateFormat: 'DD-MM-YYYY HH:mm:ss',
      productId: parseInt(localStorage.getItem('productId')),
      productName: localStorage.getItem('productName'),
      ClientId: '',
    }
    this.updateInput = this.updateInput.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.ShowHideCorporateName = this.ShowHideCorporateName.bind(this)
    this.setVisible = this.setVisible.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.setVisibleSearch = this.setVisibleSearch.bind(this)
    this.riskitem = this.riskitem.bind(this)
    this.startdateChange = this.startdateChange.bind(this)
    this.enddateChange = this.enddateChange.bind(this)
    // this.handleSubmitWithId = this.handleSubmitWithId(this);
    this.paymenttermChange = this.paymenttermChange.bind(this) //john 24-03-2022
    this.riskcoverChange = this.riskcoverChange.bind(this) //john 24-03-2022
    this.submitpolicy = this.submitpolicy.bind(this)
    this.onInputchange = this.onInputchange.bind(this)
    this.startdateChangeRiskItem = this.startdateChangeRiskItem.bind(this)
    this.state.handleSubmit = this.handleSubmit.bind(this)
    this.currencyChange = this.currencyChange.bind(this)
    this.DobFcp = this.DobFcp.bind(this)
    console.log('3')
  }


  applyMinimumPremium = (annualPremium, termPremium) => {
    const minPremium = this.state.minimumPremium
    //const appliedAnnualPremium = Math.max(roundvalue(annualPremium), minPremium);
    const appliedTermPremium = Math.max(roundvalue(termPremium), minPremium);
    const overrideNote =
      termPremium < minPremium
        ? `Applied minimum premium $${minPremium}`
        : '';
    this.setState({ overrideNotes: overrideNote });

    return { annualPremium, appliedTermPremium };
  };

  updateGrandTotals = () => {
    const totals = this.state.data.reduce(
      (acc, item) => {
        acc.prorata += Number(item.prorata || 0);
        acc.annualpremium += Number(item.annualpremium || 0);
        acc.termpremium += Number(item.termpremium || 0);
        acc.suminsured += Number(item.suminsured || 0);
        return acc;
      },
      { prorata: 0, annualpremium: 0, termpremium: 0, suminsured: 0 }
    );

    this.setState({ footerTotals: totals });

    const productName = (localStorage.getItem("productName") || "").toLowerCase();
    const isMotor = productName.includes("motor");

    const taxAmounts = this.state.taxes
      .filter(tax => {
        if (tax.taxName.toLowerCase().includes("government levy")) {
          if (!isMotor) return false;
          if (this.state.entitytype === "Individual") {
            return tax.taxName.toLowerCase().includes("private");
          } else if (this.state.entitytype === "Business") {
            return tax.taxName.toLowerCase().includes("commercial");
          }
          return false;
        }
        return true;
      })
      .map(tax => {
        let amounts;
        if (isMotor && (tax.taxName.toLowerCase().includes("private") || tax.taxName.toLowerCase().includes("commercial"))) {
          const months = Number(this.state.paymentterm) || 12;
          const prorated = (tax.ratePercentage / 12) * months;
          const levyValue = Math.max(prorated, 2);

          amounts = {
            prorata: 0,
            annualpremium: tax.ratePercentage,
            termpremium: levyValue,
          };
        } else if (tax.taxName.toLowerCase().includes("stamp duty")) {
          amounts = {
            annualpremium: Math.min(totals.annualpremium * (tax.ratePercentage / 100), 100000),
            termpremium: Math.min(totals.termpremium * (tax.ratePercentage / 100), 100000),
          };
        } else {
          amounts = {
            annualpremium: totals.annualpremium * (tax.ratePercentage / 100),
            termpremium: totals.termpremium * (tax.ratePercentage / 100),
          };
        }
        return { ...tax, amounts };
      });

    const grandTotals = {
      annualpremium: totals.annualpremium + taxAmounts.reduce((sum, t) => sum + t.amounts.annualpremium, 0),
      termpremium: totals.termpremium + taxAmounts.reduce((sum, t) => sum + t.amounts.termpremium, 0),
      prorata: totals.prorata,
    };

    this.setState({ grandTotals });
    this.setState({ totalSumInsured: totals.suminsured });
  };

  calculatePremiums = (annualPremium, termPremium, paymentTerm, isMonthlyDeduction) => {

    if (paymentTerm != 12) {
      // Spread annual premium across payment terms
      return roundvalue(termPremium / paymentTerm);
    } else {
      // If not monthly, the full annual premium is the term premium
      return roundvalue(annualPremium / 12);
    }
  };

  handleDelete = async (index) => {
    this.setState({ hasEdited: true });

    const updatedRiskItemList = [...this.state.res[0].riskitemlist];
    const deletedItem = updatedRiskItemList[index];

    try {
      // Only call backend if item has a database ID (existing item)
      if (deletedItem?.id && deletedItem.id > 0) {
        const response = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/quotation/DeleteRiskItem/${deletedItem.id}`,
          "POST"
        );

        if (!response.success) {
          message.error("Failed to delete risk item from server");
          return;
        }
      }

      // Remove from frontend state (works for both new and existing items)
      updatedRiskItemList.splice(index, 1);

      // Recalculate totals
      let prorata = 0;
      let annual_premium = 0;
      let term_premium = 0;
      let totalMonthlyPremium = 0;

      updatedRiskItemList.forEach((item) => {
        prorata += item.prorata;
        annual_premium += item.annualpremium;
        term_premium += item.termpremium;
        totalMonthlyPremium += item.monthlypremium;
      });

      // Update state
      this.setState((prevState) => {
        const updatedRes = [
          {
            ...prevState.res[0],
            riskitemlist: updatedRiskItemList,
          },
        ];
        const updatedData = [...updatedRiskItemList];

        return {
          res: updatedRes,
          data: updatedData,
          prorataPremiumTotalForEdit: roundvalue(prorata),
          annualPremiumTotalForEdit: roundvalue(annual_premium),
          termPremiumTotalForEdit: roundvalue(term_premium),
          monthlyPremiumTotal: roundvalue(totalMonthlyPremium),
          monthlyTotalPayment: totalMonthlyPremium,
          prorataPremiumTotal: roundvalue(prorata),
          annualPremiumTotal: roundvalue(annual_premium),
          termPremiumTotal: roundvalue(term_premium),
          totalSumInsured: prevState.totalSumInsured - (deletedItem?.suminsured || 0),
        };
      });

      message.success("Risk item deleted successfully");
    } catch (error) {
      console.error("Error deleting risk item:", error);
      message.error("Error deleting risk item");
    }
  };


  EditRecord = async index => {
    this.state.hasEdited = true
    const record = this.state.data[index]
    await this.riskcoverChange(record.policy_cover_id)

    await this.riskitem(parseInt(record.riskitemid));
    // debugger

    // 🔹 Lookup insurer name from insurerList by ID
    const insurerObj = this.state.insurerList.find(
      i => i.id === record.insurerId
    )

    this.props.form.setFieldsValue({
      riskItem: record.riskitemid.toString(),
      riskcover: record.policy_cover_id,
      address: record.address,
      rate: parseFloat(record.rate).toFixed(2),
      sumInsured: record.suminsured,
      itempstartdate: moment(record.itempstartdate, this.state.dateFormat),
      relation: record?.relationship,
      name: record?.membername,
      currency: record.currency,
      VehicleRegistration: this.state?.VehicleRegistration,
      Make: this.state?.Make,
      Model: this.state?.Model,
      Year: this.state?.Year,
      riskItemStartDate: moment(record.riskItemStartDate, this.state.dateFormat),
    })

    this.props.form.validateFields(['sumInsured'], { force: true });

    debugger
    this.setState({
      riskItemValue: record.riskitemid.toString(),
      riskItemName: record.riskitemname,
      policyCoverValue: record.policy_cover_id,
      rate: record.rate,
      sumInsuredValue: record.suminsured,
      DObValue: moment(record?.dateofbirth),
      relationValue: record?.relationship,
      ageFcp: record?.age,
      genderValue: record?.gender,
      VehicleRegistration: this.state?.VehicleRegistration,
      Make: this.state?.Make,
      Model: this.state?.Model,
      Year: this.state?.Year,
      editingRecordId: record.id,
      selectedInsurer: record.insurerId,
      selectedCurrency: record.currency,
      currency: record.currency,
    })
    debugger
  }

  onInputchange(event) {
    this.state.hasEdited = true
    const { name, value } = event.target
    // console.log(name, value)

    this.setState({ [name]: value })
  }

  setLoading() {
    this.setState({ loading: true })
  }

  setLoadingFalse() {
    this.setState({ loading: false })
  }

  getInsurers = async () => {
    try {
      if (this.state.isInsurer) {
        const insurer = {
          id: this.state.selectedInsurer,
          firstName: this.state.InsurerFirstName,
          lastName: this.state.InsurerLastName,
        }
        this.setState({ insurerList: [insurer] })
      } else {
        const data = JSON.parse(localStorage.getItem('user'))
        let response

        if (data?.role === '311') {
          response = await apiRequest(
            `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurersWithAllowedBrokersOfProductByBrokerId/` +
            this.state.brokerId +
            '/' +
            this.state.productId,
            'GET',
          )
        } else {
          response = await apiRequest(
            `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurersWithAllowedBrokersByProduct/` +
            this.state.productId,
            'GET',
          )
        }

        if (response.success) {
          this.setState({ insurerList: response.data })
        } else {
          console.error('API Error:', response.error)
        }
      }
    } catch (error) {
      console.error('Request failed:', error)
    }

    await apiRequest(
      `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskCoversByInsurerProductId/${this.state.specificProductID}`,
      'GET',
    )
      .then(response => {
        console.log(response)
        if (response.success && response.data) {
          const data = response.data

          this.setState({
            riskCoverDrop: data,
          })
        } else {
          console.error('API Error:', response.error)
        }
      })
      .catch(error => console.error('Error fetching Cover list:', error))
  }
  insurerChange = async (value) => {
    this.setState({ selectedInsurer: value });
    try {
      // 🔹 First API: Get Insurer Product by Insurer + Product
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetInsurerProductByInsurerIdProductId?productId=${this.state.productId}&insurerId=${value}`,
        'GET'
      );
      debugger;
      if (response.success) {
        this.setState({
          specificProductID: response?.data?.insurerProduct?.id,
          reinsuranceLimit: response?.data?.insurerProduct?.maxLimit,
          minimumPremium: response?.data?.insurerProduct?.minimumPremium,
        });
      } else {
        console.error("API Error:", response.error);
      }

      this.fetchTaxesByInsurer(value); // fetch taxes by insurer

      // Get Currencies by Insurer
      const res_2 = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetCurrenciesByInsurer/GetCurrency/${value}`,
        'GET'
      );

      if (!res_2 || res_2.success === false) {
        throw new Error("Failed to fetch currencies by insurer");
      }

      const currencies = res_2.data.data;
      // debugger;
      this.setState({ currencyList: currencies });

      let selectedCurrency = this.state.selectedCurrency;
      if (selectedCurrency) {
        const matchedCurrency = currencies.find(
          (c) =>
            c.currencyCode === selectedCurrency || c.id === selectedCurrency
        );
        if (matchedCurrency) {
          selectedCurrency = matchedCurrency.currencyName || matchedCurrency.id;
        }
      } else if (currencies.length > 0) {
        selectedCurrency = currencies[0].currencyCode;
      }
      this.setState({
        selectedCurrency: selectedCurrency,
        currency: selectedCurrency,

      });
    } catch (error) {
      console.error("Request failed:", error);
    }
    this.getInsurers();
  };

  fetchTaxesByInsurer = async (insurerId) => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetStampByInsurerId/${insurerId}`,
        "GET"
      );
      const taxes = res?.data || [];

      if (taxes.length === 0) {
        this.setState({ taxes: [] });
        message.error("No tax data found for the selected insurer.");
        return;
      }
      const selectedProductId =
        parseInt(localStorage.getItem("selectedProductId")) ||
        parseInt(this.state.productId) ||
        0; // default 0 means 'All'

      const normalizedTaxes = taxes.map((tax) => ({
        ...tax,
        specificProductId:
          tax.specificProductId !== undefined
            ? tax.specificProductId
            : tax.SpecificProductId,
      }));
      const filteredTaxes = normalizedTaxes.filter(
        (tax) =>
          tax.specificProductId === 0 ||
          tax.specificProductId === selectedProductId
      );
      const finalTaxes = filteredTaxes.length > 0 ? filteredTaxes : normalizedTaxes;

      this.setState({ taxes: finalTaxes });
    } catch (err) {
      console.error("Error fetching taxes:", err);
      this.setState({ taxes: [] });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.data !== this.state.data ||
      prevState.taxes !== this.state.taxes ||
      prevState.annualPremiumTotal !== this.state.annualPremiumTotal ||
      prevState.termPremiumTotal !== this.state.termPremiumTotal
    ) {
      this.updateGrandTotals();
    }
  }

  componentDidMount() {

    this.setState({ fieldsDisabled: true });
    this.setState({ loading: true })
    const parsed = queryString.parse(window.location.search)

    const permissions = hasPermissions('Quotation')
    const policy_permissions = hasPermissions('Policy')
    this.setState(
      {
        quotationPermissions: permissions,
        policyPermissions: policy_permissions,
      },
      () => {
        console.log(
          'Saved Quotation permissions',
          this.state.quotationPermissions,
        )
      },
    )
    if (this.state.quotationId !== null) {
      // not need to chnage
      // 'https://localhost:7246/quotation/GetQuotaionDetailsbyid/2
      apiRequest(
        process.env.REACT_APP_BASE_URL +
        '/quotation/GetQuotaionDetailsbyid/' +
        this.state.quotationId,
        'GET',
      ).then(response => {
        this.setState({ loading: false })
        this.setState({
          clientfirstname: response.data.clientdetail.clientfirstname,
          clientsurname: response.data.clientdetail.clientsurname,
          clientcontactnumber: response.data.clientdetail.clientcontactnumber,
          clientage: response.data.clientdetail.clientage,
          clientaddress1: response.data.clientdetail.clientaddress1,
          ClientId: response.data.clientdetail.id,
          nationalid: response.data.clientdetail.nationalid,
          clientcorporatename: response.data.clientdetail.clientcorporatename,
          clientemailaddress: response.data.clientdetail.clientemailaddress,
          clientId: response.data.clientdetail.id,
          clientgender: response.data.clientdetail.clientgender,
          suburb: response.data.clientdetail.suburb,
          city: response.data.clientdetail.city,
          entitytype: response.data.clientdetail.entitytype,
          currency: response.data.pquotationdetail.currency,
          selectedCurrency: response.data.pquotationdetail.currency,
          riskCoverFromApi: response.data.pquotationdetail.policyriskcover,
          isMonthlyDeduction: response.data.pquotationdetail.isMonthlyDeduction,
        })
        debugger;
        this.state.res.push(response.data.pquotationdetail)
        console.log('response initial', response.data.pquotationdetail)
        this.setState({
          totalSumInsured: response.data.pquotationdetail?.totalSumInsured || 0,
        })
        debugger;
        this.setState({ paymentterm: this.state.res[0].paymentterms })
        this.setState({ quotationNumber: this.state.res[0].quotationnumber })
        this.setState({ quotationIdLocal: this.state.res[0].quotationId })
        this.setState({ selectedInsurer: this.state.res[0].insurerId })
        this.insurerChange(this.state.res[0].insurerId)


        if (!this.state.quotationId) {
          this.insurerChange(this.state.res[0].insurerId)
        } else {

          this.getInsurers()
        }

        this.setState({ isApproved: this.state.res[0].isapproved })
        this.setState({ clientName: this.state.res[0].customername })
        this.setState({ customerId: this.state.res[0].customerid })
        this.setState({
          monthlyTermPayment: this.state.res[0].monthlyTermPayment,
        })
        this.setState({
          VehicleRegistration: this.state.res[0].vehicleRegistration,
        })
        this.setState({ Make: this.state.res[0].make })
        this.setState({ Model: this.state.res[0].model })
        this.setState({ Year: this.state.res[0].year })
        this.setState({ quotationStatus: this.state.res[0].quotationstatus })
        this.setState({
          riskItemFromApi: this.state.res[0].riskbuildingmaterial,
        })
        this.setState({
          annualPremiumTotal: this.state.res[0].totalannualpremium,
        })
        this.setState({
          termPremiumTotal: this.state.res[0].totaltermpremium,
        })
        this.setState({ policynumber: this.state.res[0].quotationnumber })
        this.setState({
          policyStartDate: this.state.res[0].policystartdate,
        })
        this.setState({
          policyexpirytdate: this.state.res[0].policyexpirytdate,
        })
        this.setState({
          brokerId: this.state.res[0].brokerId,
        })
        // this.setState({ clientId: this.state.res[0].clientid })
        this.setState({
          policyriskcover: this.state.res[0].policyriskcover,
        })

        this.setState({ newProduct: this.state.res[0].riskitemlist })
        // this.state.data.push(this.state.newProduct)
        if (Array.isArray(this.state.newProduct)) {
          this.setState({
            data: [
              ...this.state.data,
              ...this.state.newProduct.filter(item => item != null),
            ],
          })
        } else if (this.state.newProduct != null) {
          this.setState({
            data: [...this.state.data, this.state.newProduct],
          })
        }

        if (this.state.newProduct != null) {
          if (this.state.productId === 3 || this.state.productId === 5) {
            for (let i = 0; i < this.state.newProduct.length; i++) {
              console.log(this.state.newProduct[i].suminsured)

              this.setState({
                sumInsuredTotalFCP:
                  this.state.newProduct[i].suminsured +
                  this.state.sumInsuredTotalFCP,
              })
              this.setState({
                monthlyPremiumTotal:
                  this.state.newProduct[i].monthlypremium +
                  this.state.monthlyPremiumTotal,
              })
              this.setState({
                prorataPremiumTotalForEdit:
                  response.data.pquotationdetail.proratatotaltermpremium,
              })
              this.setState({
                prorataPremiumTotal:
                  response.data.pquotationdetail.proratatotaltermpremium,
              })
            }
          } else {
            for (let i = 0; i < this.state.newProduct.length; i++) {
              this.setState({
                TotalSumInsured:
                  this.state.newProduct[i].suminsured +
                  this.state.TotalSumInsured,
              })
              this.setState({
                prorataPremiumTotalForEdit:
                  this.state.newProduct[i].prorata +
                  this.state.prorataPremiumTotalForEdit,
              })
              this.setState({
                annualPremiumTotalForEdit:
                  this.state.newProduct[i].annualpremium +
                  this.state.annualPremiumTotalForEdit,
              })
              this.setState({
                termPremiumTotalForEdit:
                  this.state.newProduct[i].termpremium +
                  this.state.termPremiumTotalForEdit,
              })
            }
          }
        }

        if (
          this.state.res[0].riskitemlist?.length &&
          productNameInLocalStorage === 'LEGAL INSURANCE'
        ) {
          let total = 0
          for (let i = 0; i < this.state.res[0].riskitemlist.length; i++) {
            total =
              parseInt(total) +
              parseInt(this.state.res[0].riskitemlist[i].monthlypremium)
          }
          this.setState({ monthlyTotalPayment: parseInt(total) })
        }
      })

      apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetGloabalList/${this.state.productId}`,
        'GET',
      )
        .then(response => {
          if (response.success && response.data) {
            const data = response.data.result
            console.log("API data:", data);
            this.setState({
              stampDuty: data.mastersetting[0].stampduty,
              // currencyList: data.currencylist,
            })
          } else {
            console.error('API Error:', response.error)
          }
        })
        .catch(error => console.error('Error fetching global list:', error))
    }
    console.log('this.state.data', this.state.data[0])
  }

  currencyChange(value) {
    this.setState({ currency: value })
  }

  hideModal() {
    this.setState({
      visibleSearch: false,
    })
  }

  // Redirecting to another model where client can add customer to the database
  setVisibleSearch() {
    this.setState({
      visibleSearch: false,
    })
    this.setState({ visible: true })
  }

  // Functions for Modal functioanlity to add customers
  setVisible() {
    this.setState({ visible: true })
  }
  setVisibleFalse() {
    this.setState({ visible: false })
  }

  // Function for search functionality
  handleChange({ target }) {
    this.setState({
      [target.name]: target.value,
    })
  }

  ShowHideCorporateName(event) {
    if (event != 'Corporate') {
      this.setState({
        corporate: true,
      })
    } else {
      this.setState({
        isCorprate: false,
      })
    }
  }

  submitApproval = async e => {
    this.setState({ loading: true })

    let apiurl =
      process.env.REACT_APP_BASE_URL +
      '/quotation/ApproveQuotationStatus/approve'

    const req_body = {
      id: this.state.quotationId,
      QuotationNumber: this.state.quotationNumber,
    }
    // console.log('body data', req_body);
    try {
      const response = await apiRequest(apiurl, 'POST', req_body)
      this.setState({ loading: false })
      console.log(response)
      //  return
      if (response.success) {
        message.success('Quotation approved successfully')
        window.location.href = '/quotations'
      } else {
        message.error('Quotation could not be Approved')
        window.location.href = '/quotations'
      }
    } catch (error) {
      console.error('Error Approving the Quotation:', error)
    }
  }

  submitAuthorization = async e => {
    this.setState({ loading: true })

    let apiurl =
      process.env.REACT_APP_BASE_URL +
      `/quotation/SetQuotationInBusiness/quotation-status-newBusiness/${this.state.quotationId}`
    try {
      const response = await apiRequest(apiurl, 'POST')
      this.setState({ loading: false })
      console.log(response)
      //  return
      if (response.success) {
        message.success('Quotation approved successfully')
      } else {
        message.error('Quotation could not be Approved')
      }
      window.location.href = '/quotations'
    } catch (error) {
      console.error('Error Approving the Quotation:', error)
    }
  }

  // function for submit add policy 22 march 22 john
  submitpolicy = async e => {
    console.log(this.state.riskItemList)

    e.preventDefault()
    let apiurl = ''
    let btnvalue = e.target.value
    this.setState({ loading: true })
    // console.log('this.state.totalSumInsured', this.state.totalSumInsured)

    const { policyStartDate, dateFormat } = this.state

    if (this.state.data.length === 0) {
      message.error('Please add at least one risk item.')
      this.setState({ loading: false })
      return
    }

    if (btnvalue === 'Finalised') {
      apiurl = process.env.REACT_APP_BASE_URL + '/Policy/Addpolicy'

    } else {
      apiurl = process.env.REACT_APP_BASE_URL + '/quotation/Updatequotation'
    }
    const LoginUserData = this.state.UserDetail
    const selectedInsurerObj = this.state.insurerList.find(
      insurer => insurer.id === this.state.selectedInsurer,
    )
    const selectedInsurerEmail = selectedInsurerObj?.email || ''
    const emailRequest = {
      customerDetail: {
        customerId: this.state.clientId,
        notifyCustomer: this.state.clientemailaddress,
      },
      insurerDetail: {
        insurerId: this.state.selectedInsurer,
        notifyInsurer: selectedInsurerEmail,
      },
      brokerDetail: {
        brokerId: LoginUserData?.UserId,
        notifyBroker: LoginUserData?.email,
        brokerRole: LoginUserData?.role,
      },
    }
    let postData = {
      ...this.state.res[0],
      policyriskcover: this.state.policyriskcover,
      customeremail: this.state.clientemailaddress,
      policyexpirytdate: this.state.policyexpirytdate,
      paymentterms: this.state.paymentterm,
      grandtotalannualpremium: this.state.grandTotals.annualpremium.toFixed(2),
      grandtotaltermpremium: this.state.grandTotals.termpremium.toFixed(2),
      totalannualpremium: this.state.footerTotals.annualpremium.toFixed(2),
      totaltermpremium: this.state.footerTotals.termpremium.toFixed(2),
      isMonthlyDeduction: this.state.isMonthlyDeduction,
      monthlyTermPayment: this.calculatePremiums(roundvalue(this.state.grandTotals.annualpremium), roundvalue(this.state.grandTotals.termpremium), parseInt(this.state.paymentterm), this.state.isMonthlyDeduction),
      productid: parseInt(this.state.productId),
      productname: this.state.productName,
      nationalid: this.state.nationalid,
      proratatotaltermpremium: this.state.prorataPremiumTotalForEdit,
      emailRequest: JSON.stringify(emailRequest),
      TotalSumInsured: this.state.totalSumInsured,
      vehicleRegistration: this.state.VehicleRegistration,
      make: this.state.Make,
      model: this.state.Model,
      year: this.state.Year,
    }
    const customerdetail = {
      customerName: this.state.clientfirstname.trim(),
      customerSurname: this.state.clientsurname.trim(),
      mobile: this.state.clientcontactnumber.trim(),
      address: this.state.clientaddress1.trim(),
      nationalID: this.state.nationalid.trim(),
      age: toString(this.state.clientage),
      entityType: this.state.entitytype,
      gender: this.state.clientgender,
      city: this.state.city,
      suburb: this.state.suburb,
      emailAddress: this.state.clientemailaddress,
      corporateName: this.state.clientcorporatename,
    }
    const clientdetail = {
      clientfirstname: this.state.clientfirstname.trim(),
      clientsurname: this.state.clientsurname.trim(),
      clientcontactnumber: this.state.clientcontactnumber.trim(),
      clientaddress1: this.state.clientaddress1.trim(),
      clientaddress2: '',
      nationalid: this.state.nationalid.trim(),
      clientage: this.state.clientage,
      entitytype: this.state.entitytype,
      clientgender: this.state.clientgender,
      city: this.state.city,
      suburb: this.state.suburb,
      clientemailaddress: this.state.clientemailaddress,
      clientcorporatename: this.state.clientcorporatename,
    }
    if (
      productNameInLocalStorage === 'LEGAL INSURANCE' &&
      (btnvalue === 'Finalised' || btnvalue === 'submit')
    ) {
      let stampDutyForLegalProduct = parseFloat(
        (this.state.monthlyTotalPayment / 100) * this.state.stampDuty,
      )
      delete postData.policystartDate
    }
    try {
      await apiRequest(
        `${process.env.REACT_APP_BASE_URL}/Customers/UpdateCustomer/${this.state.ClientId}`,
        'POST',
        clientdetail,
      )
    } catch (error) {
      console.error('Error updating customer:', error)
    }
    try {
      const response = await apiRequest(apiurl, 'POST', postData)
      this.setState({ loading: false })
      // debugger
      if (btnvalue === 'Finalised') {
        message.success('Policy created successfully')
        window.location.href = '/policies'
      } else {
        message.success('Quotation created successfully')
        this.state.hasEdited = false
        window.location.href = '/quotations'
      }
    } catch (error) {
      console.error('Error submitting policy:', error)
      this.setState({ loading: false })
    }
  }

  updateInput() {
    const current = []
  }

  riskitem = (value) => {
    const selectedItem = this.state.riskItemList.find(item => item.riskItemId === value);

    if (!selectedItem) return;
    this.setState({ cellphone: false })
    this.setState({ riskitemid: value })
    for (let i = 0; i < this.state.riskItemList.length; i++) {
      if (value === this.state.riskItemList[i].riskItemId) {
        this.setState({ Minimum_rate: this.state.riskItemList[i].ratePercentage })
        this.state.riskitemfortable = this.state.riskItemList[i].riskItemName

        if (this.state.riskItemList[i].riskItemName === 'Cellphone') {
          this.setState({ cellphone: true })
        }
        if (
          this.state.riskItemList[i].riskItemName === 'Jewellery' ||
          this.state.riskItemList[i].riskItemName === 'Art'
        ) {
          this.state.coverType = 'Agreed Value'
        } else {
          this.state.coverType = 'Sum Insured'
        }
      }
    }
    this.setState({ riskItemValue: value })
  }

  showAllErrorMessages = (errorObj) => {

    if (!errorObj || typeof errorObj !== 'object') return;

    const errorEntries = Object.entries(errorObj);

    errorEntries.forEach(([fieldName, fieldData], index) => {
      const errors = fieldData?.errors;
      if (Array.isArray(errors)) {
        errors.forEach((err, errIndex) => {
          const delay = 3000 * (index + errIndex); // stagger per field and message
          setTimeout(() => {
            if (err?.message) {
              message.error(err.message);
            }
          }, delay);
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault()
    debugger;
    this.state.hasEdited = true
    let lastIndex =
      this.state.res[0].riskitemlist !== null &&
        this.state.res[0].riskitemlist.length > 0
        ? this.state.res[0].riskitemlist.length - 1
        : 0

    let lastIndexId =
      this.state.res[0].riskitemlist !== null &&
        this.state.res[0].riskitemlist.length > 0
        ? this.state.res[0].riskitemlist[lastIndex].id
        : 0

    this.props.form.validateFields((err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }
      const currentSumInsured = parseFloat(values.sumInsured || 0)
      const updatedTotal = this.state.totalSumInsured + currentSumInsured

      if (updatedTotal > this.state.reinsuranceLimit) {
        message.error('Total Sum Insured exceeds reinsurance limit')
        return
      }
      this.setState({ totalSumInsured: updatedTotal })
      let start_date = new Date(this.state.riskItemStartDate)
      let end_date = moment(new Date(this.state.policyexpirytdate), this.state.dateFormat)
      // debugger
      let Noofdays = this.findDayDifference(new Date(start_date), new Date(end_date),)

      if (!err) {
        let riskstartdate = new Date(this.state.riskItemStartDate)
        let riskenddate = new Date(this.state.policyexpirytdate)
        debugger;
        let annualpremium = roundvalue(
          (values.sumInsured / 100) * this.state.rate,
        )
        let termpremium = 0
        // if (this.state.monthlyTermPayment) {
        //   termpremium =
        //     ((values.sumInsured / 100) * this.state.rate) /
        //     parseInt(this.state.policyDuration)
        // } else {
        if (this.state.paymentterm == 3) {
          termpremium = annualpremium / 4
        } else if (this.state.paymentterm == 4) {
          termpremium = annualpremium / 3
        } else if (this.state.paymentterm == 6) {
          termpremium = annualpremium / 2
        } else if (this.state.paymentterm == 12) {
          termpremium = annualpremium
        }
        // }

        debugger;
        const minPremium = Number(this.state.minimumPremium || 0);

        if (termpremium < minPremium) {
          termpremium = minPremium;
          message.success(`Minimum premium of $${minPremium} applied`);
        };

        const overrideNote = (termpremium < minPremium)
          ? `Applied minimum premium $${minPremium}`
          : '';
        this.setState({ overrideNotes: overrideNote });


        const prorata = roundvalue(
          (values.sumInsured / 100) * this.state.rate * (Noofdays / 365),
        )

        this.state.newProduct = {
          id: lastIndexId + 1,
          address: values.address,
          suminsured: values.sumInsured,
          rate: this.state.rate,
          annualpremium,
          termpremium,
          prorata,
          policynumber: this.state.quotationNumber,
          policy_cover: this.state.policyriskcover,
          policy_cover_id: this.state.riskcoverid,
          riskitemid: this.state.riskItemValue.toString(),
          riskitemname: this.state.riskItemList.filter(x => x.riskItemId == parseInt(this.state.riskItemValue))[0].riskItemName,
          policyquotatonid: this.state.res[0].id,
          itempstartdate: riskstartdate.toGMTString(),
          itempexpirydate: riskenddate.toGMTString(),

          monthlypremium:
            productNameInLocalStorage === 'LEGAL INSURANCE'
              ? this.state.rate
              : 0,
        }

        if (productNameInLocalStorage === 'LEGAL INSURANCE') {
          this.state.newProduct = {
            ...this.state.newProduct,
            annualpremium: 0,
            termpremium: 0,
            suminsured: 0,
            prorata: 0,
            itempexpirydate: '',
            membername: '',
            gender: '',
            age: '',
            premiumfactor: 0,
            relationship: '',
            grand_total: 0,
          }
        }

        // Push to list
        if (!this.state.res[0].riskitemlist) {
          this.state.res[0].riskitemlist = []
        }

        this.state.res[0].riskitemlist.push(this.state.newProduct)
        this.setState(prevState => ({
          data: [...prevState.data, this.state.newProduct],
        }))

        // Recalculate totals
        let totalMonthlyPremium = 0
        let annual_premium = 0
        let term_premium = 0
        let pro_rata = 0

        this.state.res[0].riskitemlist.forEach(item => {
          pro_rata += item.prorata
          annual_premium += item.annualpremium
          term_premium += item.termpremium
          totalMonthlyPremium += parseInt(item.monthlypremium)
        })

        this.setState({
          monthlyTotalPayment: totalMonthlyPremium,
          prorataPremiumTotalForEdit: pro_rata,
          annualPremiumTotalForEdit: annual_premium,
          termPremiumTotalForEdit: term_premium,
          prorataPremiumTotal: roundvalue(pro_rata),
          annualPremiumTotal: roundvalue(annual_premium),
          termPremiumTotal: roundvalue(term_premium),
        })

        this.props.form.resetFields([
          'policyCover',
          'riskItem',
          'address',
          'sumInsured',
        ])

        this.setState({
          riskItemValue: 'Select',
          policyCoverValue: 'Select',
          monthlyPaymentValues: 0,
          addressValue: '',
          sumInsuredValue: 0,
          rate: 0,
          Minimum_rate: 0,
        })

        this.props.form.setFieldsValue({
          riskcover: '',
        })
      }
    })
  }

  handleEditSubmit = e => {
    e.preventDefault();
    debugger;
    this.props.form.validateFields(async (err, values) => {
      if (err) {
        this.showAllErrorMessages(err);
        return;
      }
      if (!err) {
        try {
          // debugger
          // Get the edited record from state
          const editedRecord = this.state.data.find(item =>
            item.id === this.state.editingRecordId
          );

          if (!editedRecord) {
            message.error('Record not found for editing');
            return;
          }

          // Calculate dates
          const start_date = new Date(this.state.riskItemStartDate)
          const end_date = moment(new Date(this.state.policyexpirytdate), this.state.dateFormat)
          const Noofdays = this.findDayDifference(
            new Date(start_date),
            new Date(end_date)
          );

          // Calculate premiums
          let annualpremium = roundvalue(
            (values.sumInsured / 100) * this.state.rate
          );

          let termpremium = 0;
          // if (this.state.monthlyTermPayment) {
          //   termpremium =
          //     ((values.sumInsured / 100) * this.state.rate) /
          //     parseInt(this.state.policyDuration);
          // } else {

          if (this.state.paymentterm == 3) {
            termpremium = annualpremium / 4;
          } else if (this.state.paymentterm == 4) {
            termpremium = annualpremium / 3;
          } else if (this.state.paymentterm == 6) {
            termpremium = annualpremium / 2;
          } else if (this.state.paymentterm == 12) {
            termpremium = annualpremium;
          }
          // }

          debugger;
          const minPremium = Number(this.state.minimumPremium || 0); // dynamic only

          if (termpremium < minPremium) {
            termpremium = minPremium;
            message.success(`Minimum premium of $${minPremium} applied`);
          };

          const overrideNote = (termpremium < minPremium)
            ? `Applied minimum premium $${minPremium}`
            : '';
          this.setState({ overrideNotes: overrideNote });


          const prorata = roundvalue(
            (values.sumInsured / 100) * this.state.rate * (Noofdays / 365)
          );

          // Format dates
          const riskstartdate = new Date(this.state.riskItemStartDate);
          const riskenddate = new Date(this.state.policyexpirytdate);

          // Create updated risk item
          const updatedRiskItem = {
            ...editedRecord, // Keep existing properties
            address: values.address,
            suminsured: values.sumInsured,
            rate: this.state.rate,
            annualpremium,
            termpremium,
            prorata,
            policy_cover_id: this.state.riskcoverid,
            riskitemid: this.state.riskitemid.toString(),
            riskitemname: this.state.riskitemfortable,
            itempstartdate: riskstartdate.toGMTString(), // Format as needed

            itempenddate: riskenddate.toGMTString(), // Format as needed

            monthlypremium: productNameInLocalStorage === 'LEGAL INSURANCE' ? this.state.rate : 0,
          };

          // Update the risk item in res[0].riskitemlist
          const updatedRiskItemList = this.state.res[0].riskitemlist.map(item =>
            item.id === updatedRiskItem.id ? updatedRiskItem : item
          );

          // Update the data array
          const updatedData = this.state.data.map(item =>
            item.id === updatedRiskItem.id ? updatedRiskItem : item
          );

          // Recalculate totals
          let totalMonthlyPremium = 0;
          let annual_premium = 0;
          let term_premium = 0;
          let pro_rata = 0;
          let TotalSumInsured = 0;

          updatedRiskItemList.forEach(item => {
            pro_rata += item.prorata;
            annual_premium += item.annualpremium;
            term_premium += item.termpremium;
            totalMonthlyPremium += parseInt(item.monthlypremium);
            TotalSumInsured += parseInt(item.suminsured);
          });

          // Update state
          this.setState({
            res: [{
              ...this.state.res[0],
              riskitemlist: updatedRiskItemList
            }],
            data: updatedData,
            monthlyTotalPayment: totalMonthlyPremium,
            prorataPremiumTotalForEdit: pro_rata,
            annualPremiumTotalForEdit: annual_premium,
            termPremiumTotalForEdit: term_premium,
            prorataPremiumTotal: roundvalue(pro_rata),
            annualPremiumTotal: roundvalue(annual_premium),
            termPremiumTotal: roundvalue(term_premium),
            editingRecordId: null, // Clear editing state
            TotalSumInsured: TotalSumInsured,
          });

          // Reset form fields
          this.props.form.resetFields([
            'policyCover',
            'riskItem',
            'address',
            'sumInsured',
          ]);

          this.setState({
            riskItemValue: 'Select',
            policyCoverValue: 'Select',
            monthlyPaymentValues: 0,
            addressValue: '',
            sumInsuredValue: 0,
            rate: 0,
            Minimum_rate: 0,
          });

          this.updateGrandTotals();

          message.success('Risk item updated successfully!');

        } catch (error) {
          console.error('Error updating risk item:', error);
          message.error('Failed to update risk item');
        }
      }
    });
  };

  handleSubmitForFCP = e => {
    e.preventDefault()
    debugger;
    const { form, quotationnumber } = this.props
    const {
      res,
      data,
      riskItemStartDate,
      rate,
      riskitemid,
      riskitemfortable,
      ageFcp,
      policyriskcover,
      riskcoverid,
      totalSumInsured,
    } = this.state

    this.setState({ hasEdited: true })

    const riskItemList = res?.[0]?.riskitemlist || []
    const lastIndexId =
      riskItemList.length > 0
        ? riskItemList[riskItemList.length - 1]?.id || 0
        : 0

    form.validateFields(
      (err, values) => {
        if (err) {
          this.showAllErrorMessages(err);
          return;
        }

        console.log('values', values)

        const currentSumInsured = parseFloat(values.sumInsured || 0)
        const updatedTotalSumInsured = totalSumInsured + currentSumInsured

        if (updatedTotalSumInsured > this.state.reinsuranceLimit) {
          message.error('Total Sum Insured exceeds reinsurance limit')
          return
        }

        let start_date = new Date(this.state.riskItemStartDate)
        let end_date = new Date(this.state.policyexpirytdate)
        let Noofdays = this.findDayDifference(
          new Date(start_date),
          new Date(end_date),
        )

        const sumInsuredInThousands = currentSumInsured / 1000
        const monthlyPremium =
          sumInsuredInThousands > 0
            ? parseFloat(
              (sumInsuredInThousands * parseFloat(rate || 0)).toFixed(2),
            )
            : parseFloat(rate || 0)

        const riskStartDate = new Date(riskItemStartDate)
        const riskenddate = new Date(this.state.policyexpirytdate);
        const formattedStartDate = `${riskStartDate.getFullYear()}-${riskStartDate.getMonth() + 1
          }-${riskStartDate.getDate()}`
        const annualpremium = roundvalue(
          (values.sumInsured / 100) * this.state.rate,
        )
        let termpremium = 0
        if (this.state.monthlyTermPayment) {
          termpremium =
            ((values.sumInsured / 100) * this.state.rate) /
            parseInt(this.state.policyDuration)
        } else {
          if (this.state.paymentterm === 3) {
            termpremium = ((values.sumInsured / 100) * this.state.rate) / 4
          } else if (this.state.paymentterm === 4) {
            termpremium = ((values.sumInsured / 100) * this.state.rate) / 3
          } else if (this.state.paymentterm === 6) {
            termpremium = ((values.sumInsured / 100) * this.state.rate) / 2
          } else if (this.state.paymentterm === 12) {
            termpremium = (values.sumInsured / 100) * this.state.rate
          }
        }
        // const termpremium = roundvalue(
        //   ((values.sumInsured / 100) * this.state.rate) / 3,
        // )
        const prorata = roundvalue(
          (values.sumInsured / 100) * this.state.rate * (Noofdays / 365),
        )

        let newProductForFCP = {
          id: lastIndexId + 1,
          riskitemid: String(riskitemid),
          riskitemname: riskitemfortable,
          rate: parseFloat(rate || 0),
          gender: values.genderFCP,
          membername: values.name,
          relationship: values.relation,
          suminsured: currentSumInsured,
          premiumfactor: sumInsuredInThousands || 0,
          monthlypremium: monthlyPremium,
          age: ageFcp,
          policyquotatonid: 0,
          itempstartdate: riskStartDate.toGMTString(), // Format as needed
          policy_cover: policyriskcover,
          policy_cover_id: riskcoverid,

          address: '',
          policynumber: quotationnumber,
          annualpremium: annualpremium,
          termpremium: termpremium,
          prorata: prorata,
          itempexpirydate: riskenddate.toGMTString(), // Format as needed
          grand_total: 0,
        }

        // Step 4: Update res[0].riskitemlist
        const updatedRes = [...this.state.res]
        if (!updatedRes[0].riskitemlist) {
          updatedRes[0].riskitemlist = []
        }
        updatedRes[0].riskitemlist.push(newProductForFCP)

        // Step 5: Update data array
        const updatedData = [...this.state.data, newProductForFCP]

        // Step 6: Recalculate totals
        let sumInsuredTotal = 0
        let monthlyPremiumTotal = 0
        let annual_premium = 0
        let term_premium = 0
        let pro_rata = 0
        updatedData.forEach(item => {
          sumInsuredTotal += item.suminsured
          monthlyPremiumTotal += item.monthlypremium
          pro_rata += item.prorata
          annual_premium += item.annualpremium
          term_premium += item.termpremium
        })
        console.log(updatedData)

        this.setState({
          data: updatedData,
          newProductForFCP,
          totalSumInsured: updatedTotalSumInsured,
          sumInsuredTotalFCP: roundvalue(sumInsuredTotal),
          monthlyPremiumTotal: roundvalue(monthlyPremiumTotal),
          prorataPremiumTotalForEdit: roundvalue(pro_rata),
          annualPremiumTotalForEdit: roundvalue(annual_premium),
          termPremiumTotalForEdit: roundvalue(term_premium),
          prorataPremiumTotal: roundvalue(pro_rata),
          annualPremiumTotal: roundvalue(annual_premium),
          termPremiumTotal: roundvalue(term_premium),
        })

        // form.resetFields(); // Optional
      },
      () => {
        // Safe to access this.state here
        console.log(
          'Updated:',
          this.state.prorataPremiumTotal,
          this.state.annualPremiumTotalForEdit,
          this.state.termPremiumTotalForEdit,
        )
      },
    )
  }

  findDayDifference(date1, date2) {
    // always round down
    // debugger
    return Math.floor(Math.abs(date2 - date1) / (1000 * 60 * 60 * 24))
  }
  startdateChangeRiskItem(date, datestring) {
    if (datestring === '') {
      message.warning('Risk item start date cannot be null')
    } else {
      if (new Date(this.state.policyexpirytdate) < new Date(datestring)) {
        message.error('Invalid Date')
      } else {
        this.setState({ riskItemStartDate: datestring })
      }
    }
  }

  startdateChange(date, datestring) {
    if (datestring === '') {
      message.warning('Start date cannot be empty')
    } else if (new Date(datestring) >= new Date(this.state.currentDate)) {
      this.setState({ policyStartDate: new Date(datestring) })
      var year = new Date(datestring).getFullYear()
      var month = new Date(datestring).getMonth()
      var day = new Date(datestring).getDate()
      var Newdate = new Date(year + 1, month, day)
      this.setState({ policyexpirytdate: Newdate })
    } else {
      message.warning('Start date cannot be smaller than Current Date')
    }
  }

  enddateChange(date, datestring) {
    if (datestring === '') {
      message.warning('End date cannot be empty.')
    } else {
      if (new Date(this.state.policyStartDate) < new Date(datestring)) {
        this.setState({ policyexpirytdate: new Date(datestring) })
      } else {
        message.error('Invalid Duration ')
      }
    }
  }

  DobFcp(date, datestring) {
    this.setState({ DObValue: date })

    if (this.state.policyriskcover.length > 0) {
      var a = moment()
      var b = moment(date)
      var daysOld = a.diff(b, 'days')
      var monthsOld = a.diff(b, 'months')
      var yearsOld = a.diff(b, 'years') // 1

      var agesuffix =
        yearsOld === 1
          ? 'year'
          : yearsOld > 1
            ? 'years'
            : monthsOld === 1
              ? 'month'
              : monthsOld > 1
                ? 'months'
                : daysOld === 1
                  ? 'day'
                  : 'days'
      if (yearsOld > 0) {
        this.setState({ ageFcp: yearsOld.toString() + ' ' + agesuffix })
      } else if (monthsOld > 0) {
        this.setState({ ageFcp: monthsOld.toString() + ' ' + agesuffix })
      } else {
        this.setState({ ageFcp: daysOld.toString() + ' ' + agesuffix })
      }
      for (let i = 0; i < this.state.riskItemList.length; i++) {
        var rname = this.state.riskItemList[i].riskItemName
        var range = rname.replace(/[^\d.]/g, '')
        var Range1 = 0
        var Range2 = 0
        if (range.length > 3) {
          Range1 = parseInt(range.substring(0, 2))
          Range2 = parseInt(range.slice(-2))
        } else if (range.length === 3) {
          Range1 = parseInt(range.substring(0, 1))
          Range2 = parseInt(range.slice(-2))
          if (yearsOld === 0) {
            this.setState({ rate: this.state.riskItemList[i].ratepercentage })
          }
        }
        if (yearsOld > 0 && range.length > 3) {
          if (yearsOld <= Range2 && yearsOld >= Range1) {
            this.setState({ rate: this.state.riskItemList[i].ratepercentage })
          } else if (yearsOld > 80) {
            this.setState({ rate: [] })
          }
        }
      }
    } else {
      datestring = null
      message.warning('Please select Policy Cover')
    }
  }

  getRiskCoverName = val => {
    const { riskCoverDrop } = this.state
    const cover = riskCoverDrop.find(item => item.riskCoverId === Number(val))
    return cover ? cover.riskCoverName : null
  }


  async riskcoverChange(value) {
    this.setState({ policyriskcover: value.toString() })
    debugger
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_INSURER}/api/Insurer/GetRiskItemsByCoverId/${value}/${this.state.selectedInsurer}`,
        'GET',
      )

      if (response.success == false) {
        this.setState({
          riskItemList: [],
        })
      }
      if (response.success && response.data.length > 0) {
        const res_data = response.data

        const selectedCoverName = this.getRiskCoverName(value)
        // console.log(selectedCoverName);

        this.setState({
          riskItemList: res_data,
          policyriskcover: selectedCoverName,
          riskcoverid: value,
          Minimum_rate: res_data[0].ratePercentage,
        })
      }
    } catch (error) {
      console.error('Error fetching risk cover:', error)
    }

    this.setState({ policyCoverValue: value })
  }

  paymenttermChange(value) {
    //  select paymentterm john
    var monthsToBeAdded = parseInt(this.state.policyDuration)
    this.setState({ paymentterm: value })
    var year = new Date(this.state.policyStartDate).getFullYear()
    var month =
      new Date(this.state.policyStartDate).getMonth() + monthsToBeAdded
    var day = new Date(this.state.policyStartDate).getDate()
    var Newdate = new Date(year, month, day)
    this.setState({ policyexpirytdate: Newdate })
  }

  componentWillUnmount() {
    localStorage.removeItem('clientId')
  }

  render() {
    const { getFieldDecorator } = this.props.form

    let riskCoverList =
      this.state.riskCoverDrop.length > 0 &&
      this.state.riskCoverDrop.map((item, i) => {
        return (
          <option key={i} value={item.riskCoverId}>
            {item.riskCoverName}
          </option>
        )
      }, this)
    const paymenttermList = [3, 4, 6, 12].map(term => (
      <Select.Option key={term} value={term.toString()}>
        {term}
      </Select.Option>
    ))
    let riskNameList =
      this.state.riskItemList.length > 0 &&
      this.state.riskItemList.map((item, i) => {
        return (
          <Select.Option key={i} value={item.riskItemId}>
            {item.riskItemName}
          </Select.Option>
        )
      }, this)


    let currencyList =
      this.state.currencyList.length > 0 &&
      this.state.currencyList.map((item, i) => {
        return (
          <Select.Option key={item.i} value={item.currencyCode}>
            {item.currencyName + '-' + item.currencyCode}
          </Select.Option>
        )
      }, this)
    let InsuranceList =
      this.state.insurerList.length > 0 &&
      this.state.insurerList.map((item, i) => {
        return (
          <Select.Option key={item.id} value={item.id}>
            {`${item.name}`}
          </Select.Option>
        )
      }, this)

    return (
      <Layout className="dashboard">
        <Spin
          className="loader-icon-fixed"
          spinning={this.state.loading}
          size="large"></Spin>
        <div className=" dash-bg-white">
          <Row>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div className="flex justify-between">
                <h5
                  style={{
                    color: '#F15A2B',
                    fontWeight: '500',
                    fontSize: '20px',
                    marginBottom: '0',
                  }}>
                  <b>
                    Edit Quotation{' '}
                    {/* <label
                      style={{
                        color: '#F15A2B',
                        fontWeight: '700',
                        fontSize: '20px',
                      }}>
                        {this.state.productName}
                    </label> */}
                  </b>
                </h5>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <div className="right-text align-left">
                {this.state.quotationIdLocal !== null && (
                  <label>
                    <b>Quotation Number : {this.state.quotationNumber}</b>
                  </label>
                )}
              </div>
            </Col>
          </Row>
        </div>
        <div className=" dash-bg-white">
          <div className="d-inline-block">
            <Row gutter={[16, 24]}>
              <Col xs={12} sm={24} md={12} lg={12}>
                <h3
                  style={{
                    color: '#F15A2B',
                    fontWeight: '700',
                    fontSize: '20px',
                    margin: '0',
                  }}>
                  Basic Customer Details
                </h3>
              </Col>
              <Col xs={12} sm={24} md={12} lg={12}>
                <div className="align-right">
                  <Button
                    size="default"
                    onClick={() => window.location.href = '/quotations'}
                    style={{
                      color: '#6c757d',
                      borderColor: '#6c757d',
                      marginRight: '10px'
                    }}>
                    Go Back
                  </Button>
                  {this.state.policyPermissions.hasOwnProperty('11') &&
                    this.state.isApproved && (
                      <Button
                        size="default"
                        value={'Finalised'}
                        onClick={this.submitpolicy}
                        style={{
                          marginLeft: 'auto',
                          color: '#fd7e14',
                          borderColor: '#fd7e14',
                        }}>
                        Approve
                      </Button>
                    )}
                </div>
              </Col>
            </Row>
          </div>

          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Entity Type">
                <Input
                  disabled
                  value={this.state.entitytype}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            {this.state.clientfirstname !== '' && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="First Name">
                  <Input
                    // disabled
                    name="clientfirstname"
                    placeholder="Enter Firstname"
                    onChange={this.onInputchange}
                    value={
                      this.state.clientfirstname.includes('undefined')
                        ? this.state.clientfirstname.slice(9)
                        : this.state.clientfirstname
                    }
                  />
                </Form.Item>
              </Col>
            )}
            {this.state.clientsurname !== '' && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Sur Name">
                  <Input
                    // disabled
                    name="clientsurname"
                    onChange={this.onInputchange}
                    placeholder="Enter surname"
                    value={this.state.clientsurname}
                  />
                </Form.Item>
              </Col>
            )}
            {this.state.entitytype === 'Business' && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Corporate Name">
                  <Input
                    // disabled
                    name="clientcorporatename"
                    onChange={this.onInputchange}
                    value={this.state.clientcorporatename}
                    placeholder="Corporate name"
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Contact Number">
                <Input
                  name="clientcontactnumber"
                  onChange={this.onInputchange}
                  placeholder="eg:987654321"
                  value={this.state.clientcontactnumber}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Email Address">
                <Input
                  name="clientemailaddress"
                  onChange={this.onInputchange}
                  placeholder="abc@gmail.com "
                  value={this.state.clientemailaddress}
                />
              </Form.Item>
            </Col>
            {this.state.clientage !== 0 && (
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Age">
                  <Input
                    placeholder="eg:24"
                    name="clientage"
                    // disabled
                    onChange={this.onInputchange}
                    value={this.state.clientage}
                  />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="National Id">
                <Input
                  name="nationalid"
                  disabled
                  placeholder="National Id"
                  value={this.state.nationalid}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={8}>
              <Form.Item label="Address">
                <TextArea
                  name="clientaddress1"
                  onChange={this.onInputchange}
                  placeholder="Enter Address"
                  value={this.state.clientaddress1}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24} md={12} lg={8}>
            <Form.Item label=" Address 2">
              <TextArea placeholder="Enter Address" value={this.state.clientaddress2} />
            </Form.Item>
          </Col> */}
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Suburb">
                <Input
                  placeholder="Enter Suburb"
                  name="suburb"
                  onChange={this.onInputchange}
                  value={this.state.suburb}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="City">
                <Input
                  placeholder="Enter City"
                  name="city"
                  onChange={this.onInputchange}
                  value={this.state.city}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className=" dash-bg-white">
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
              marginBottom: '20px',
            }}>
            Policy Details
          </h3>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Insurer List">
                <Select
                  disabled={(this.state.fieldsDisabled)}
                  defaultValue="--Select option--"
                  onChange={this.insurerChange}
                  value={this.state.selectedInsurer || undefined}
                  // {disableInsurer == true ? 'disabled': ''}
                  style={{ display: 'inline' }}>
                  {InsuranceList}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Policy Start Date">
                <DatePicker
                  disabled={this.state.fieldsDisabled}
                  // disabled={ this.state.quotationPermissions.hasOwnProperty('20')}

                  value={moment(
                    new Date(this.state.policyStartDate),
                    this.state.dateFormat,
                  )}
                  style={{ width: '100%' }}
                  placeholder="Policy Start Date"
                  onChange={this.startdateChange}
                  disabledDate={current => {
                    // Disable dates before today
                    return current && current < moment(this.state.policyStartDate,
                      this.state.dateFormat);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Payment Term">
                <Select
                  disabled={this.state.fieldsDisabled}
                  // disabled={this.state.quotationPermissions.hasOwnProperty(
                  //   '20',
                  // )}
                  value={this.state.paymentterm}
                  onChange={this.paymenttermChange}
                  defaultValue="Payment Term"
                  style={{ display: 'inline' }}>
                  {paymenttermList}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={20} md={12} lg={4}>
              <Form.Item label="Is Monthly Deduction">
                <Checkbox
                  checked={this.state.isMonthlyDeduction}
                  onChange={e =>
                    this.setState({ isMonthlyDeduction: e.target.checked })
                  }
                />
              </Form.Item>
            </Col>


            {/* {(this.state.productId === 1 ||
              this.state.productId === 2 ||
              this.state.productId === 4) &&
              productNameInLocalStorage !== 'LEGAL INSURANCE' ? ( */}
            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Policy End Date">
                <DatePicker
                  value={moment(
                    new Date(this.state.policyexpirytdate),
                    this.state.dateFormat,
                  )}
                  // disabled
                  style={{ width: '100%' }}
                  placeholder="Policy End Date"
                  onChange={this.enddateChange}
                />
              </Form.Item>
            </Col>
            {/* ) : (
              ''
            )} */}
            <Col xs={24} md={12} lg={4}>
              <Form.Item label="Currency">
                <Select
                  value={this.state.selectedCurrency}
                  onChange={(value) => this.setState({ selectedCurrency: value })}
                  disabled={this.state.fieldsDisabled}
                  placeholder="Select Currency"
                >

                  {currencyList}
                </Select>

              </Form.Item>
            </Col>


            <Col xs={24} md={12} lg={5}>
              <Form.Item label="Insurance Limit">
                <Input value={this.state.reinsuranceLimit} disabled />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="dash-bg-white">
          <h3
            style={{
              color: '#F15A2B',
              fontWeight: '700',
              fontSize: '20px',
              margin: '0',
              marginBottom: '20px',
            }}>
            Product Details
          </h3>
          <Form
            onSubmit={
              this.state.productId === 3 || this.state.productId === 5
                ? this.handleSubmitForFCP
                : this.handleSubmit
            }
            id="my-form">
            <Row gutter={[16, 24]}>
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Policy Cover">
                  {getFieldDecorator('riskcover', {
                    rules: [{ required: true, message: 'Please select a Policy Cover!' }],
                    initialValue: this.state.policyCoverValue, // optional
                  })(
                    <Select
                      placeholder="Select Policy Cover"
                      onChange={this.riskcoverChange}
                      style={{ display: 'inline' }}
                    >
                      {this.state.riskCoverDrop.map(item => (
                        <Select.Option key={item.riskCoverId} value={item.riskCoverId}>
                          {item.riskCoverName}  {/* Name is displayed */}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Risk Item">
                  {getFieldDecorator('riskItem', {
                    rules: [{ required: true, message: 'Please select a Risk Item!' }],
                    initialValue: this.state.riskItemValue, // <-- must be string ID
                  })(
                    <Select
                      placeholder="Select Risk Item"
                      onChange={value => this.setState({ riskItemValue: value })}
                    >
                      {this.state.riskItemList.map(item => (
                        <Select.Option key={item.riskItemId} value={item.riskItemId.toString()}>
                          {item.riskItemName} {/* Name will show */}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>

              </Col>



              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Date of Birth">
                    <DatePicker
                      disabledDate={current =>
                        current.isAfter(moment().subtract(1, 'day')) ||
                        current.isBefore(moment().subtract(64, 'years'))
                      }
                      onChange={this.DobFcp}
                      style={{ width: '100%' }}
                      value={this.state.DObValue}
                    />
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Age">
                    <Input
                      placeholder="eg:24"
                      value={this.state.ageFcp}
                      disabled
                    />
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Relationship">
                    {getFieldDecorator('relation', {
                      initialValue: '',
                      rules: [
                        {
                          required: this.state.isRequired,

                          message: 'Please input Relationship!',
                        },
                      ],
                    })(
                      <select
                        className="select-input"
                        id="relationshipValue"
                        value={this.state.relationValue}>
                        <option value="">---Select--</option>
                        <option value="Principal Member">
                          Principal Member
                        </option>
                        <option value="Spouse">Spouse</option>
                        <option value="Child">Child</option>
                        <option value="Grand Parent">Grand Parent</option>
                        <option value="Other">Other</option>
                      </select>,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Name">
                    {getFieldDecorator('name', {
                      initialValue: '',
                      rules: [
                        {
                          required: this.state.isRequired,

                          message: 'Please input Name!',
                        },
                      ],
                    })(<Input
                    // placeholder="Name" 
                    />)}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {this.state.productId === 3 || this.state.productId === 5 ? (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label="Gender">
                    {getFieldDecorator('genderFCP', {
                      initialValue: '',
                      rules: [
                        {
                          required: this.state.isRequired,

                          message: 'Please input gender!',
                        },
                      ],
                    })(
                      <select
                        className="select-input"
                        value={this.state.genderValue}>
                        <option value="">---Select--</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </select>,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {/* {(this.state.cellphone === false && this.state.productId === 1) ||
                (this.state.cellphone === false && this.state.productId === 2) ||
                (this.state.cellphone === false && this.state.productId === 4) ? ( */}
              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Address/Item Details">
                  {getFieldDecorator('address', {
                    rules: [
                      {
                        required: true,
                        message: 'Please input Address!',
                        whitespace: false,
                      },
                    ],
                  })(<Input
                  // placeholder="Address/Item Details"
                  />)}
                </Form.Item>
              </Col>


              {this.state.cellphone === false &&
                this.state.productId !== 5 &&
                productNameInLocalStorage !== 'LEGAL INSURANCE' ? (
                <Col xs={24} md={12} lg={3}>
                  <Form.Item label="Sum Insured">


                    {getFieldDecorator('sumInsured', {
                      rules: [
                        {
                          required: true,
                          message: 'Please input Amount!',
                          whitespace: false,
                        },
                        {
                          validator: (_, value, callback) => {
                            if (!value) {
                              callback();
                              return;
                            }

                            const { minimumPremium, currency, currencyRates } = this.state;
                            const numericValue = Number(value);

                            if (isNaN(numericValue)) {
                              callback('Amount must be a number!');
                              return;
                            }

                            // Get selected currency code (from state or form)
                            const selectedCurrency = currency || this.props.form.getFieldValue('currency');
                            // Get conversion rates
                            const fromRate = currencyRates && currencyRates[selectedCurrency] ? currencyRates[selectedCurrency].conversionRate : 1;
                            const toRate = currencyRates && currencyRates['USD'] ? currencyRates['USD'].conversionRate : 1;

                            if (!fromRate || !toRate) {
                              callback('Currency conversion rate not available');
                              return;
                            }

                            // Convert entered value to USD
                            const amountInUSD = (numericValue / fromRate) * toRate;

                            if (amountInUSD < minimumPremium) {
                              callback(`Amount must be greater than or equal to ${minimumPremium} USD`);
                            } else {
                              callback();
                            }
                          },
                        },
                      ],
                    })(
                      <Input
                        // value={this.state.sumInsuredValue}
                        placeholder="Amount"
                      />,
                    )}
                  </Form.Item>
                </Col>
              ) : (
                ''
              )}

              {productNameInLocalStorage === 'LEGAL INSURANCE' ? (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item label={'Minimum Monthly Payment'}>
                    <Input
                      placeholder={'Minimum Monthly Payment'}
                      disabled
                      value={parseFloat(this.state.Minimum_rate).toFixed(2)}
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col xs={24} md={12} lg={4}>
                  <Form.Item
                    label={
                      this.state.productId === 3
                        ? 'Minimum Rate'
                        : this.state.productId === 5
                          ? 'Minimum Pay-out'
                          : 'Minimum Rate(%)'
                    }>
                    <Input
                      disabled
                      value={parseFloat(this.state.Minimum_rate).toFixed(2)}
                    />
                  </Form.Item>
                </Col>
              )}

              {productNameInLocalStorage !== 'LEGAL INSURANCE' && (
                <Col xs={24} md={12} lg={2}>
                  <Form.Item
                    label={
                      this.state.productId === 3
                        ? 'Rate'
                        : this.state.productId === 5
                          ? 'PayOut'
                          : 'Rate(%)'
                    }>
                    {getFieldDecorator('rate', {
                      initialValue: this.state.rate !== undefined ? parseFloat(this.state.rate).toFixed(2) : undefined,
                      rules: [
                        {
                          required: true,
                          message: 'Please enter Rate!',
                          whitespace: false,
                        },
                        {
                          validator: (_, value, callback) => {
                            if (!value) {
                              callback('Please enter Rate!');
                              return;
                            }

                            const rateValue = parseFloat(value);
                            const minRate = parseFloat(this.state.Minimum_rate || 0);

                            if (isNaN(rateValue)) {
                              callback('Please enter a valid number');
                            } else if (rateValue <= minRate) {
                              callback(`Rate must be greater than ${minRate}`);
                            } else {
                              callback();
                            }
                          },
                        },
                      ],
                    })(
                      <Input
                        onChange={e => {
                          this.setState({ rate: e.target.value });
                          // Trigger validation after state update
                          setTimeout(() => this.props.form.validateFields(['rate']), 0);
                        }}
                      />,
                    )}
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} md={12} lg={4}>
                <Form.Item label="Start Date">
                  <DatePicker
                    style={{ width: '100%' }}
                    // placeholder="Risk item  start date"
                    value={moment(
                      this.state.riskItemStartDate,
                      this.state.dateFormat,
                    )}
                    onChange={this.startdateChangeRiskItem}
                  />
                </Form.Item>
              </Col>

              {this.state.productId === 10 && (
                <>
                  <Col xs={24} md={12} lg={3}>
                    <Form.Item label="Vehicle Registration">
                      {getFieldDecorator('VehicleRegistration ', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter Vehicle Registration!',
                            whitespace: false,
                          },
                        ],
                      })(
                        <Input
                          value={this.state.VehicleRegistration}
                          // placeholder="Vehicle Registration"
                          onChange={e =>
                            this.setState({
                              VehicleRegistration: e.target.value,
                            })
                          }
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={3}>
                    <Form.Item label="Make ">
                      {getFieldDecorator('Make', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter Make!',
                            whitespace: false,
                          },
                        ],
                      })(
                        <Input
                          value={this.state.Make}
                          // placeholder="Make "
                          onChange={e => this.setState({ Make: e.target.value })}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={3}>
                    <Form.Item label="Model">
                      {getFieldDecorator('Model', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter Model!',
                            whitespace: false,
                          },
                        ],
                      })(
                        <Input
                          value={this.state.Model}
                          // placeholder="Model"
                          onChange={e => this.setState({ Model: e.target.value })}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={3}>
                    <Form.Item label="Year ">
                      {getFieldDecorator('Year ', {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter Year!',
                            whitespace: false,
                          },
                        ],
                      })(
                        <Input
                          value={this.state.Year}
                          // placeholder="Year "
                          onChange={e => this.setState({ Year: e.target.value })}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </>
              )}

              {this.state.editingRecordId == null && (<Col xs={24} md={12} lg={3}>
                <div className="add-button">
                  <Button
                    htmlType="submit"
                    size="default"
                    className="add-secondary">
                    Add
                  </Button>
                </div>
              </Col>)}
              {this.state.editingRecordId != null && (
                <Col xs={24} md={12} lg={3}>
                  <div className="add-button">
                    <Button
                      type="button"
                      size="default"
                      className="add-secondary"
                      onClick={this.handleEditSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Col>)}
            </Row>
          </Form>
        </div>
        <div className="dash-bg-white no-padding">
          <div
            className={
              this.state.productId !== 3
                ? 'table-grid-bx width-11'
                : 'table-grid-bx width-11 col-th-10'
            }>
            <Table
              rowKey={record => record.id}
              className="table-scroll-auto"
              columns={
                this.state.productId === 3 || this.state.productId === 5
                  ? this.state.columnsForFCP
                  : this.state.columns
              }
              dataSource={this.state.data}
              pagination={false}
              footer={() => {
                const totals = {
                  annualpremium: Number(this.state.annualPremiumTotal) || 0,
                  termpremium: Number(this.state.termPremiumTotal) || 0,
                };

                const productName = (localStorage.getItem("productName") || "").toLowerCase();
                const isMotor = productName.includes("motor");

                let taxAmounts = this.state.taxes
                  .filter(tax => {
                    // Motor: include government levy filtered by entity type
                    if (tax.taxName.toLowerCase().includes("government levy")) {
                      if (!isMotor) return false;
                      if (this.state.entitytype === "Individual") return tax.taxName.toLowerCase().includes("private");
                      if (this.state.entitytype === "Business") return tax.taxName.toLowerCase().includes("commercial");
                      return false;
                    }
                    return true; // include all other taxes
                  })
                  .map(tax => {
                    let amounts = {};

                    if (isMotor && tax.taxName.toLowerCase().includes("government levy")) {
                      // Dynamically prorate based on payment term and tax rate
                      const months = Number(this.state.paymentterm) || 12; // fallback if paymentterm missing
                      const prorated = (tax.ratePercentage / 12) * months;
                      const levyValue = Math.max(prorated, 0); // optional: enforce min if needed

                      amounts = {
                        annualpremium: tax.ratePercentage, // yearly rate from tax
                        termpremium: levyValue,
                      };
                    } else if (tax.taxName.toLowerCase().includes("stamp duty")) {
                      amounts = {
                        annualpremium: Math.min(totals.annualpremium * (tax.ratePercentage / 100), 100000),
                        termpremium: Math.min(totals.termpremium * (tax.ratePercentage / 100), 100000),
                      };
                    } else {
                      amounts = {
                        annualpremium: totals.annualpremium * (tax.ratePercentage / 100),
                        termpremium: totals.termpremium * (tax.ratePercentage / 100),
                      };
                    }

                    return { ...tax, amounts };
                  });

                const grandTotals = {
                  annualpremium: totals.annualpremium + taxAmounts.reduce((sum, t) => sum + (t.amounts.annualpremium || 0), 0),
                  termpremium: totals.termpremium + taxAmounts.reduce((sum, t) => sum + (t.amounts.termpremium || 0), 0),
                };

                const renderHeadingRow = () => (
                  <div style={{ display: "flex", borderBottom: "2px solid #000", padding: "8px 0", fontWeight: "bold", background: "#fafafa" }}>
                    <div style={{ flex: 1, textAlign: "left", padding: "0 8px" }}></div>
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>Annual Premium</div>
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>Term Premium</div>
                  </div>
                );

                const renderRow = (label, values, isBold = false) => (
                  <div style={{ display: "flex", borderBottom: "1px solid #e8e8e8", padding: "8px 0", fontWeight: isBold ? "bold" : "normal" }}>
                    <div style={{ flex: 1, textAlign: "left", padding: "0 8px" }}>{label}</div>
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>{values.annualpremium?.toFixed(2) || ""}</div>
                    <div style={{ flex: 1, textAlign: "right", padding: "0 8px" }}>{values.termpremium?.toFixed(2) || ""}</div>
                  </div>
                );

                return (
                  <div>
                    {renderHeadingRow()}
                    {renderRow("Total", this.state.footerTotals)}
                    {taxAmounts.map((tax, idx) => renderRow(tax.taxName, tax.amounts))}
                    {renderRow("Grand Total", this.state.grandTotals, true)}
                  </div>
                );
              }}
            />

          </div>
          <div className="btn-group-success">
            {this.state.quotationPermissions.hasOwnProperty('20') &&
              !this.state.hasEdited &&
              !this.state.isApproved &&
              this.state.quotationStatus !== 'Draft' && (
                <Button
                  className="btn-success"
                  size="default"
                  value={'submit'}
                  disabled={this.state.hasEdited}
                  onClick={this.submitApproval}>
                  Confirm
                </Button>
              )}
            {this.state.quotationPermissions.hasOwnProperty('12') &&
              this.state.quotationStatus !== 'Draft' && (
                <Button
                  disabled={!this.state.hasEdited}
                  className="btn-success"
                  size="default"
                  value={'submit'}
                  onClick={this.submitpolicy}>
                  Save
                </Button>
              )}
            {this.state.quotationPermissions.hasOwnProperty('11') &&
              this.state.quotationStatus === 'Draft' && (
                <Button
                  // disabled={!this.state.hasEdited}
                  className="btn-success"
                  size="default"
                  value={'submit'}
                  onClick={this.submitAuthorization}>
                  Authorize
                </Button>
              )}
          </div>
        </div>
      </Layout>
    )
  }
}

const WrappedEditQuotation = Form.create({ name: 'Homeinsurance_list' })(
  withRouter(EditQuotation),
)

export default WrappedEditQuotation
